import { createAction } from '@reduxjs/toolkit';
import { normalizeError } from 'core/common/errors';
import { HumanDesignReportError } from 'core/common/errors/HumanDesignReportError';
import { AppThunk } from 'core/common/store/types';
import { HumanDesignReport } from 'core/human-design/entities';
import { getUserInformation } from 'core/user/store/selectors';

export const fetchReportPending = createAction('humanDesignReport/FETCH_REPORT/pending');
export const fetchReportSucceed = createAction<HumanDesignReport>(
  'humanDesignReport/FETCH_REPORT/succeed',
);
export const fetchReportFailed = createAction('humanDesignReport/FETCH_REPORT/failed');

export const fetchHumanDesignReport = (): AppThunk => async (dispatch, getState, services) => {
  const { humanDesignReportService, loggingService: logger } = services;

  const { name, time, place, location, date } = getUserInformation(getState());

  dispatch(fetchReportPending());

  try {
    if (!name || !date || !place.length || !location) {
      throw new HumanDesignReportError('Mandatory data for report generating is missing');
    }

    const report = await humanDesignReportService.generateReport({
      name,
      birthDate: date,
      birthPlace: {
        location,
        longitude: place[0],
        latitude: place[1],
      },
      birthTime: time ?? '00:00:00',
    });

    dispatch(fetchReportSucceed(report));
  } catch (e) {
    const err = normalizeError(e);

    logger.error(err);
    dispatch(fetchReportFailed());
  }
};
